import { DummyAdapter } from "./adapters/Dummy";
import { ErrorTrackerFactory } from "./trackerFactory";

const errorTracker = ErrorTrackerFactory(DummyAdapter());

export { errorTracker };
